import { GET_INTERNATIONAL_COUNTRY_REQUEST, GET_INTERNATIONAL_COUNTRY_SUCCESS, GET_INTERNATIONAL_COUNTRY_ERROR } from "./types.js"
import { BASEURL } from "../../constant/config.js"
import axios from "axios";

export const getInternationalCountry = (token) => dispatch => {
    dispatch({ type: GET_INTERNATIONAL_COUNTRY_REQUEST });
    return axios({
        method: "POST",
        url: `${BASEURL}getAll/InternationalCountry`,
        headers: {
            Accept: "application/json",
            'Authorization': 'Bearer ' + token
        }
    })
        .then(response => {

            return dispatch({ type: GET_INTERNATIONAL_COUNTRY_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            return dispatch({
                type: GET_INTERNATIONAL_COUNTRY_ERROR,
                payload: error.response,
            });
        })
}

